import { cn } from "@/lib/utils";
import { Inbox } from "lucide-react";

function EmptyState({
  icon: Icon = Inbox,
  title = "No data",
  description,
  children,
  className,
}) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12 px-4 text-center", className)}>
      <Icon className="h-12 w-12 text-muted-foreground/50 mb-4" />
      <h3 className="text-lg font-medium text-foreground mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-sm">{description}</p>
      )}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}

export { EmptyState };
